<script setup lang="ts">
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import BaseInputText from '../../../base/BaseInputText.vue'
import { IdentificationIcon, ReceiptTaxIcon } from '@heroicons/vue/solid'
import {
    isNaturalProfileAttributeHidden,
    isRequiredNaturalProfileAttributesForInvestment,
    isRequiredRequiredNaturalProfileAttributes,
} from '../../../../validation'
import { initPersonalAccountForm } from '../../../../utilities/account/useAccountFormPersonal'
import { getPlatformSettings } from '../../../../utilities/usePlatformSettings'
import TaxResidencyFormFields from '../../../wizard/ESAC/form/fields/TaxResidencyFormFields.vue'

const { naturalProfile: account } = usePersonalAccountDataState()

initPersonalAccountForm('Tax Data')

function taxResidenciesActivated() {
    console.log(getPlatformSettings().compliance_profile)
    return getPlatformSettings().compliance_profile === 'esac'
}
</script>

<template>
    <TaxResidencyFormFields v-if="taxResidenciesActivated()"></TaxResidencyFormFields>

    <div class="grid grid-cols-1 gap-x-4 gap-y-8 px-4 py-5 sm:grid-cols-2 sm:px-6">
        <div v-if="!isNaturalProfileAttributeHidden('social_security_number')" class="sm:col-span-1">
            <BaseInputText
                v-model="account.social_security_number"
                :required="isRequiredRequiredNaturalProfileAttributes('social_security_number')"
                :required-2="isRequiredNaturalProfileAttributesForInvestment('social_security_number')"
                :icon="IdentificationIcon"
                name="account.social_security_number"
                :label="$t('account.social_security_number')" />
        </div>
        <div v-if="!isNaturalProfileAttributeHidden('tax_number')" class="sm:col-span-1">
            <BaseInputText
                v-model="account.tax_number"
                :icon="ReceiptTaxIcon"
                :required="isRequiredRequiredNaturalProfileAttributes('tax_number')"
                :required-2="isRequiredNaturalProfileAttributesForInvestment('tax_number')"
                name="account.tax_number"
                :label="$t('account.tax_number')" />
        </div>
    </div>
</template>
